export default __webpack_public_path__ + "static/media/city-portrait.a8cb3094.png";